<template>
  <v-container
    grid-list-md
    text-xs-center>
    <v-layout
      row
      wrap>
      <v-flex xs12>
        <h2>{{ checkingAuthentication ? '' : 'krita.login.header' | translate }}</h2>
      </v-flex>
      <v-flex xs12>
        <v-form v-if="!checkingAuthentication">
          <v-container
            fluid
            grid-list-md>
            <v-layout
              row
              wrap
              align-center
              justify-center>
              <v-flex
                xs12
                md8>
                <v-text-field
                  :label="usernameLabel"
                  v-model="username"
                  :error="errors.state"
                  :error-messages="errors.label"
                  prepend-icon="person"
                  name="Username"
                  clearable
                  autocomplete="username"/>
              </v-flex>
              <v-flex
                xs12
                md8>
                <v-text-field
                  :label="passwordLabel"
                  v-model="password"
                  :error="errors.state"
                  :error-messages="errors.label"
                  prepend-icon="lock"
                  name="Password"
                  type="password"
                  clearable
                  autocomplete="current-password"
                  @keyup.13="Login"/>
              </v-flex>
              <v-flex xs8>
                <v-checkbox
                  v-model="rememberLogin.value"
                  :label="rememberLogin.label"
                />
              </v-flex>
              <v-flex xs8>
                <v-btn
                  v-if="!waitingForLoginResult"
                  color="accent"
                  large
                  block
                  @click="Login">{{ 'krita.login.loginaction' | translate }}</v-btn>
                <v-progress-circular
                  v-if="waitingForLoginResult"
                  indeterminate
                  color="accent"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-layout
          v-if="checkingAuthentication"
          align-center
          justify-center
          column
          fill-height>
          <v-layout row>
            <v-flex
              xs1
              text-center
              my-2>
              <v-progress-circular
                class="icon-offset"
                indeterminate
                color="accent"
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <div class="title font-weight-light">{{ 'krita.login.passtrough' | translate }}</div>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
	import { mapState } from 'vuex';
	export default {
		name: 'Login',
		data() {
			return {
				username: '',
				password: '',
				usernameLabel: this.$t('krita.login.label.user'),
				passwordLabel: this.$t('krita.login.label.password'),
                rememberLogin: {
				  label: this.$t('krita.login-remember'),
                  value: false
                },
				errors: {
					state: false,
					label: []
				},
				waitingForLoginResult: false,
                checkingAuthentication: false
			};
		},
		computed: mapState({
			backLink: state => state.backLink,
            credentials: state => state.credentials
		}),
		mounted ()
        {
			// if (self.$store.state.credentials.isAuthorized && self.$store.state.credentials.user !== '' && self.$store.state.credentials.password !== '') {
			// 	self.username = self.$store.state.credentials.user;
			// 	self.password = self.$store.state.credentials.password;
			// 	self.Login();
			// }

          let self = this;

          self.checkingAuthentication = false;
          self.waitingForLoginResult = false;
          self.IsAuthorized ();
		},
		methods: {
			Login()
            {
				let self = this;

				if (self.waitingForLoginResult === true) { return; }

				self.waitingForLoginResult = true;

				self.errors.state = false;
				self.errors.label = [];

				self.$store.dispatch('getToken', {user: self.username, password: self.password, rememberLogin: self.rememberLogin.value}).then(response => {
					self.getUser();
				}, error => {
                      self.waitingForLoginResult = false;
                      self.$store.commit('notification/showNotificationInternal', {type:'error', msg: 'krita.notification.loginfailed'});
                      /*
                      self.errors.state = true;
                      self.errors.label = [self.$t('login.error.userOrPass')];
                      */
					});
			},
          getUser ()
          {
            let self = this;
            let getUser = self.$store.dispatch('user/getUser');
            getUser.then(response =>
            {
              if (response.AccessToCompanies.length === 0)
              {
                self.waitingForLoginResult = false;
                self.$store.commit('notification/showNotificationInternal', {type:'error', msg: 'krita.notification.loginfailed.noclaimantsonuser'});
                self.$router.push('/log-in');
                self.$store.commit('logOut');
                return;
              }
              self.$store.commit('setUser', response);
              self.LoginSuccess();
            }, (e) =>
            {
              self.checkingAuthentication = false;
              self.waitingForLoginResult = false;
              self.$store.commit('notification/showNotificationInternal', {type:'error', msg: 'krita.notification.loginfailed.getuserinfo'});
              self.$router.push('/log-in');
              self.$store.commit('logOut');
            }
            );
          },
          LoginSuccess ()
          {
            let self = this;

            self.$store.commit('setAuthorized', true);
            self.$router.push(self.backLink !== '' ? self.backLink : '/claims');
          },
          IsAuthorized ()
          {
            let self = this;

            self.checkingAuthentication = true;

            if (self.credentials.token !=='')
            {
              if (self.credentials.refreshToken !== '')
              {
                let refresh = self.$store.dispatch('getTokenFromRefresh', {rememberLogin: true});
                refresh.then(response => {
                  self.$store.commit('clearDownloadedLanguagesList');
                  self.getUser();
                }).catch(error => {
                  self.$store.commit('setToken','');
                  self.checkingAuthentication = false;
                });
              }
              else
              {
                self.$store.commit('setToken','');
                self.checkingAuthentication = false;
              }
            }
            else
            {
              self.checkingAuthentication = false;
            }
          }
		}
	};
</script>
<style lang="scss">
  // anti retard fix :(
  .theme--light.v-icon{
    color: rgba(0,0,0,.54) !important;
    &.accent--text {
      color: #1976d2 !important;
      caret-color: #1976d2 !important;
    }
  }

</style>
